import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { take, tap } from 'rxjs/operators';
import { AppConfigurationService } from '../modules/core/services/app-configuration.service';
import { FeatureName } from '../modules/shared/enums/feature-name';

@Injectable()
export class FeatureFlagGuard  {

  constructor(
    private router: Router,
    private appConfigurationService: AppConfigurationService
  ) { }

  canActivate(route: ActivatedRouteSnapshot) {
    const flag = route.data.flag as FeatureName;

    return this.appConfigurationService.getFeatureFlag(flag).pipe(
      take(1),
      tap(enabled => {
        if (!enabled) {
          this.router.navigateByUrl('/notfound');
        }
      })
    );
  }
}

export const featureFlagGuard = (feature: FeatureName, redirectRoute = '/notfound', shouldRedirect = true): CanActivateFn => () => {
  const router = inject(Router);
  const appConfigurationService = inject(AppConfigurationService);

  return appConfigurationService.getFeatureFlag(feature).pipe(
    take(1),
    tap(enabled => {
      if (shouldRedirect && !enabled) {
        router.navigateByUrl(redirectRoute);
      }
    })
  );
};
